import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { baseQuery, endpoints } from 'utils/api/endpoints';
import { State } from './types';

export const initialState: State = {
  selectedErrorLog: null,
};

const slice = createSlice({
  name: 'errorLogs',
  initialState,
  reducers: {
    setSelectedErrorLog: (state, action: PayloadAction<any>) => {
      state.selectedErrorLog = action.payload;
    },
  },
});

export const api = createApi({
  reducerPath: 'errorLogsApi',
  baseQuery,
  tagTypes: ['errorLogs'],
  endpoints: builder => ({
    getErrorLogs: builder.query<any, any>({
      query: params => ({
        url: endpoints.ERROR_LOGS,
        method: 'GET',
        params,
      }),
      providesTags: ['errorLogs'],
    }),
    getErrorLogStats: builder.query<any, any>({
      query: () => ({
        url: endpoints.ERROR_LOGS_STATS,
        method: 'GET',
      }),
      providesTags: ['errorLogs'],
    }),
    getErrorLogById: builder.query<any, any>({
      query: id => ({
        url: `${endpoints.ERROR_LOGS}/${id}`,
        method: 'GET',
      }),
    }),
    resolveErrorLog: builder.mutation<any, any>({
      query: ({ id, data }) => ({
        url: `${endpoints.ERROR_LOGS}/${id}/resolve`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['errorLogs'],
    }),
    deleteErrorLog: builder.mutation<any, any>({
      query: id => ({
        url: `${endpoints.ERROR_LOGS}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['errorLogs'],
    }),
    bulkDeleteErrorLogs: builder.mutation<any, any>({
      query: params => ({
        url: endpoints.ERROR_LOGS_BULK_DELETE,
        method: 'DELETE',
        params,
      }),
      invalidatesTags: ['errorLogs'],
    }),
  }),
});

export const { actions: ErrorLogsAction } = slice;

export const useErrorLogsSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    useGetErrorLogsQuery: api.useLazyGetErrorLogsQuery,
    useGetErrorLogStatsQuery: api.useLazyGetErrorLogStatsQuery,
    useGetErrorLogByIdQuery: api.useLazyGetErrorLogByIdQuery,
    useResolveErrorLogMutation: api.useResolveErrorLogMutation,
    useDeleteErrorLogMutation: api.useDeleteErrorLogMutation,
    useBulkDeleteErrorLogsMutation: api.useBulkDeleteErrorLogsMutation,
    actions: ErrorLogsAction,
  };
};
